export const getSubdomain = () => {
    const hostname = window.location.hostname.split('.');
    return process.env.NODE_ENV === "development"
        ? "pizzaria"
        : hostname[0];
}
